import { render } from "./ClavierView.vue?vue&type=template&id=51930b8a"
import script from "./ClavierView.vue?vue&type=script&lang=js"
export * from "./ClavierView.vue?vue&type=script&lang=js"

import "./ClavierView.vue?vue&type=style&index=0&id=51930b8a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__